import {
  IotaClient,
  IotaTransactionBlockResponse,
} from '@iota/iota-sdk/client';
import {
  IdentifierString,
  IotaSignTransactionFeature,
} from '@iota/wallet-standard';
import { WalletWithFeatures } from '@wallet-standard/base';
import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { Env } from 'modules/common';

import { createStakeTransaction } from './createStakeTransaction';

interface IStakeParams {
  chainId: IdentifierString;
  wallet: WalletWithFeatures<IotaSignTransactionFeature>;
  walletAccount: WalletAccount;
  client: IotaClient;
  amount: BigNumber;
  env: Env;
}

export async function stake({
  chainId,
  wallet,
  walletAccount,
  client,
  amount,
  env,
}: IStakeParams): Promise<IotaTransactionBlockResponse> {
  const { transaction } = createStakeTransaction(env, walletAccount, amount);

  const signedTransaction = await wallet.features[
    'iota:signTransaction'
  ].signTransaction({
    chain: chainId,
    transaction,
    account: walletAccount,
  });

  return client.executeTransactionBlock({
    transactionBlock: signedTransaction.bytes,
    signature: signedTransaction.signature,
  });
}
